import { TableCell, TableRow } from "@material-ui/core";
import { FC, memo, useCallback } from "react";
import { ShiftRecordCell } from "./ShiftRecordCell";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { updateReportRecordAction } from "actions/shiftTrackerActions";
import { useDispatch } from "react-redux";

interface FleetReportRowProps {
  index: number;
  rowId: number;
  columns: { id: string }[];
  classes: any;
  shiftDate: string;
  shiftStation: number;
  disabledByDate: boolean;
  canCreateOldShifts: boolean;
}

export const ShiftRecordRow: FC<FleetReportRowProps> = memo(
  ({ index, rowId, columns, classes, shiftDate, shiftStation, disabledByDate, canCreateOldShifts }) => {
    const dispatch = useDispatch();
    const row = useTypeSelectors((state) =>
      state.dasBoard.currentReport.find((record) => record.id === rowId),
    );

    const handleUpdateCell = useCallback(
      (data: any) => {
        if (row?.id) {
          dispatch(updateReportRecordAction(row.id, data));
        }
      },
      [row?.id, dispatch],
    );

    if (!row) return null;

    const conditionForDisabledEdit = canCreateOldShifts
      ? false
      : (row.status_assigned_by_sms && [2, 3].includes(row.da_status)) ||
          [2, 3].includes(row.da_status)
        ? true
        : disabledByDate;

    return (
      <TableRow>
        {columns.map((item) => (
          <TableCell key={`shift-record-cell-${item.id}-${row.id}`} className={`${classes.tableCell} ${classes.fixedHeight}`}>
          <ShiftRecordCell
            key={`${row.id}-${item.id}`}
            index={index}
            columnId={item.id}
            cellData={row}
            shiftDate={shiftDate}
            shiftStation={shiftStation}
            classes={classes}
            disabledCondition={conditionForDisabledEdit}
            disabledByDate={disabledByDate}
            handleUpdateCell={handleUpdateCell}
          />
          </TableCell>
        ))}
      </TableRow>
    );
  },
);
